import React, { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import { getRunAuditLog } from "../../../../../../services/payroll";
import { tokens, radius } from "../../../../../../theme";

const ACTION_TONE = {
  RUN_CREATED: tokens.accent,
  RUN_EDITED: tokens.warning,
  RUN_APPROVED: tokens.success,
  RUN_REJECTED: tokens.danger,
  RUN_PAID: tokens.accent,
  EXPENSES_RESYNCED: tokens.accent,
};
const fmt = (d) => (d ? new Date(d).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "");

// render one field-change; adjustments use an added/removed shape, others are from→to
const money0 = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
const fmtChange = (field, v) => {
  if (field === "adjustments" && (v?.added || v?.removed)) {
    const parts = [];
    (v.added || []).forEach((a) => parts.push(`+${a.name} ${a.type === "DEDUCTION" ? "−" : "+"}${money0(a.amount)}`));
    (v.removed || []).forEach((a) => parts.push(`removed ${a.name}`));
    return parts.join(", ") || "adjustments changed";
  }
  return `${field} ${v.from}→${v.to}`;
};

const RunAuditPanel = ({ runId, refreshKey }) => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    if (!runId) return;
    let active = true;
    (async () => {
      try {
        const res = await getRunAuditLog(runId);
        if (active) setLogs(Array.isArray(res?.data) ? res.data : []);
      } catch { /* non-critical */ }
    })();
    return () => { active = false; };
  }, [runId, refreshKey]);

  if (logs.length === 0) return null;

  return (
    <Box sx={{ background: tokens.card, border: `1px solid ${tokens.border}`, borderRadius: `${radius.card}px`, p: "1.5rem", mt: "1.5rem" }}>
      <Box sx={{ fontSize: "0.9375rem", fontWeight: 600, mb: "1.25rem" }}>History &amp; Audit Trail</Box>
      <Stack spacing={0}>
        {logs.map((l, i) => {
          const who = l.actor ? `${l.actor.fname || ""} ${l.actor.lname || ""}`.trim() : "System";
          const tone = ACTION_TONE[l.action] || tokens.textMuted;
          return (
            <Stack key={l._id || i} direction="row" spacing={1.5} sx={{ pb: "1rem", position: "relative" }}>
              {/* timeline dot + line */}
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", pt: "0.25rem" }}>
                <Box sx={{ width: "0.625rem", height: "0.625rem", borderRadius: "50%", background: tone, flexShrink: 0 }} />
                {i < logs.length - 1 && <Box sx={{ width: "1px", flex: 1, background: tokens.border, mt: "0.25rem" }} />}
              </Box>
              <Box sx={{ flex: 1 }}>
                <Box sx={{ fontSize: "0.875rem", fontWeight: 600, color: tokens.text }}>{l.message}</Box>
                <Box sx={{ fontSize: "0.8125rem", color: tokens.textMuted, mt: "0.25rem" }}>
                  {fmt(l.createdAt)} · {who}{l.reason ? <> · <Box component="span" sx={{ fontStyle: "italic" }}>“{l.reason}”</Box></> : null}
                </Box>
                {Array.isArray(l.changes) && l.changes.map((c, ci) => (
                  <Box key={ci} sx={{ fontSize: "0.8125rem", color: tokens.textMuted, mt: "0.25rem", pl: "0.5rem", borderLeft: `2px solid ${tokens.border}` }}>
                    <b>{c.name}</b>: {Object.entries(c.fields || {}).map(([f, v]) => fmtChange(f, v)).join(", ")}
                  </Box>
                ))}
              </Box>
            </Stack>
          );
        })}
      </Stack>
    </Box>
  );
};

export default RunAuditPanel;
